import "react-app-polyfill/ie11";
import "core-js/stable";
import React, { useState, useEffect, useRef, useContext ,forwardRef, useImperativeHandle} from "react";
import Refresh from "../images/svg/Refresh.svg";
import Minimize from "../images/svg/Minimize.svg";
import Close from "../images/svg/Close.svg";
import getCWACookies from "../util/getCWACookies";
import MaximizeIcon from "../images/svgLatest/Expand_black.png";
import RestoreIcon from "../images/svgLatest/Collapse_black.png";
import ChatModal from "./Modal";
import ChatbotLogo from "../images/svgLatest/ChatbotLogo.svg";
import ChatbotLogo_HBT from "../images/svgLatest/ChatbotLogo_HBT.svg";
import ChatbotLogo_NewHBT from "../images/svgLatest/ChatbotLogo_NewHBT.svg";
import HeaderLogo from "../images/svgLatest/HeaderLogo.svg";
import HeaderLogo_HBT from "../images/svgLatest/HeaderLogo_HBT.svg";
import MenuIcon from "../images/svgLatest/MenuIcon.svg";
import "../css/ripple-animation.css";
import { AppContext } from "../util/appContext";
import { Components } from "botframework-webchat-component";
import liveAgentStaticLabels from "../util/liveAgentStaticLabels.json";
import salesPagesMessages from "../util/salesPagesMessages.json";
import { setCookie, getCookie } from '../util/cookieActions';
import messageSound from "../sounds/Chatbot_Notification.mp3";
import StaticLabels from "../util/staticLabels.json";
import disableProactivity from "../util/disableProactivity";
const momenttimezone = require('moment-timezone');

var classNames = require("classnames");

const Header = forwardRef(({
  isMaximised,
  handleMaximizeChange,
  handleModalChange,
  isOpenModal,
  handleSurveyCardChange,
  userLanguage,
  headerIconsDisplay,
  surveyLink,
  store,
  directLine,
  handleRefreshModalPopup,
  handleCloseModalPopup,
  isSurveyOpen
},ref) => {
  var headerClass = classNames({
    headerMax: isMaximised,
    headerMin: isMaximised,
    header: true
  });
  var agentBadge = classNames({
    agentBadge: true,
    displayNone: !isMaximised
  });
  const [currentPageTitle, setCurrentPageTitle] = useState("")
  const [currentPageLanguage, setCurrentPageLanguage] = useState("")
  const [currentCountrySelectedOnPortal, setCurrentCountrySelectedOnPortal] = useState("")
  const [isWindowFocused, setIsWindowFocused] = useState(document.visibilityState === 'visible');
  const [isChatOpen, setisChatOpen] = useState(isMaximised);

  const [localMaximized, setLocalMaximized] = useState(isMaximised);

  useEffect(() => {
    const onVis = () => setIsWindowFocused(document.visibilityState === 'visible')
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  },[]);

  useEffect(() => {
    const savedMaximizeState =getCookie(window.config.businessUnit + '-adjustResize');
    if (savedMaximizeState == true || savedMaximizeState=="true"){
      setLocalMaximized(true);
    }else{
      setLocalMaximized(false);
    }
    },[])
  const context = useContext(AppContext);
  const HBTPages = window.config.postLoginSalesPages;
  const BrandBasedPages = window.config.brandBasedPages;

  const resizeWindowScreen_Latest=()=>{
    const rootMax = document.querySelector('.root-max');
    // Get window width
    if(rootMax){
    document.getElementById("root").removeAttribute("style");
    const windowWidth = window.screen.width;
    console.log(windowWidth,"..windowWidth");
    if(window.config.isAccessibilityFeature){
    document.getElementById("root").classList.remove("adjustResize");
    }
    if(window.config.isAdjustable){
    if(getCookie(window.config.businessUnit + '-adjustResize')){
      if(window.config.isAccessibilityFeature){
      document.getElementById("root").classList.add("adjustResize");
      }
      if (windowWidth >= 1601) {
        rootMax.style.width = '800px';
        rootMax.style.height = '750px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '700px';
        rootMax.style.height ='525px';
      }
    }
    else{
      if (windowWidth >= 1601) {
        rootMax.style.width = '425px';
        rootMax.style.height = '600px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '375px';
        rootMax.style.height ='500px';
      }
    }
    }
    else{
      if (windowWidth >= 1601) {
        rootMax.style.width = '425px';
        rootMax.style.height = '650px';
      } else if (windowWidth <= 1600) {
        rootMax.style.width = '375px';
        rootMax.style.height ='500px';
      }
    }
    // Apply styles based on window width
    
    }
    else{
    window.parent.postMessage({key:'minimise', launcherIcon: false}, window.config.pageOrigin);
    }
  }
  const toggleMaximize = () => {
    if(getCookie(window.config.businessUnit + '-adjustResize')){
      setCookie(window.config.businessUnit + '-adjustResize', false);
      setLocalMaximized(false);
    }
    else{
      setCookie(window.config.businessUnit + '-adjustResize', true);
      setLocalMaximized(true);
    }
    resizeWindowScreen_Latest();
    window.parent.postMessage({key:'maximise',isAdjustable:window.config.isAdjustable,adjustResize:getCookie(window.config.businessUnit + '-adjustResize')}, window.config.pageOrigin);
  };

  const handleMenuClick = () => {
    context.setMenuOpen(!context.menuOpen);
  }

  const closeIconClick = () => {
    if (store != null) {
      store.dispatch({ //Send CloseBot event
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "closeWithFeedback",
          value: getCWACookies("cwaSSOToken")
        }
      });
    }
  }
  const [messages, setMessages] = useState([]);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const UNREAD_KEY = "unread_count"
  const pingRef = useRef(null);
  const originalTitleRef = useRef(document.title);
  const flashTimerRef = useRef(null);

  const startTabFlash = (count) => {
    if(flashTimerRef.current) return;
    let on = false;
    flashTimerRef.current = setInterval(() => {
      on = !on;
      document.title = on
      ? `New Message ${count > 1 ? `${(count)}` : ''}`
      : originalTitleRef.current;
    }, 900);
  };

  const stopTabFlash = () => {
    if(flashTimerRef.current){
      clearInterval(flashTimerRef.current);
      flashTimerRef.current = null;
    }
    document.title = originalTitleRef.current
  };

  useEffect(() => {
    const isChatOpen = isMaximisedRef.current
    const shouldFlash = unreadMessageCount > 0 && (!isWindowFocused || !isChatOpen);

    if(shouldFlash){
      startTabFlash(unreadMessageCount);
    }else{
      stopTabFlash();
    }
    return () => stopTabFlash();
  },[unreadMessageCount, isWindowFocused, isMaximised])

  useEffect(() =>{
    const a = new Audio(messageSound);
    a.preload = 'auto';
    pingRef.current = a;
  }, [messageSound])

  useEffect(() => {
    const unlock = () =>{
      const a =pingRef.current;
      if (!a) return;
      a.muted = true;
      a.play()
      .then(() => {
        a.pause();
        a.currentTime = 0;
        a.muted = false;
      })
      .catch(() => {})
};
window.addEventListener('pointerdown',unlock, {once:true});
window.addEventListener('keydown',unlock, {once:true});
return () => {
  window.removeEventListener('pointerdown',unlock);
  window.removeEventListener('keydown',unlock);
}
  }, [])

  const isRealAgentBubble = (activity) => {
  if (!activity || activity.name !== "agentmessages") return false;
  const msg = activity.value?.message || "";
  return !msg.includes("ChatSessionEnded");
};

  const focusedRef = useRef(isWindowFocused);

   useEffect(() => {
    // Update the ref whenever isWindowFocused changes
    focusedRef.current = isWindowFocused;
    console.log("isWindowFocused?", focusedRef.current);
  }, [isWindowFocused]);

  const isMaximisedRef = useRef(isMaximised);

  useEffect(() => {
    // Update the ref whenever isMaximised changes
    isMaximisedRef.current = isMaximised;
  }, [isMaximised]);

  useEffect(() => {
    const handleVisibilityChange = () => {
 if(document.visibilityState === 'visible'){
  setIsWindowFocused(true);
 }else{
  setIsWindowFocused(false);
 }
 };
 document.addEventListener("visibilitychange", handleVisibilityChange);
 
 setIsWindowFocused(document.visibilityState);
 return () => {
  document.removeEventListener("visibilitychange", handleVisibilityChange);
 };
  }, []);

  useEffect(() => {
    console.log("Tab is focused?", isWindowFocused)
  }, [isWindowFocused]);

  const handleBotIconClick = () => {
    setUnreadMessageCount(0);
    
  };

//Checking if recent message is read or unread
  const handleIncomingMessage = (activity) => {
    if (activity.name !== "agentmessages" || activity.value.label == "System") return;
    
    const isChatOpen = isMaximisedRef.current;
    const focused = focusedRef.current
    const shouldPlaySound = !focused || !isChatOpen;
    const isRead = focused && isChatOpen

      const message = {
        id: activity.id,
        text: activity.text || "",
        read: isRead,
      };
      setMessages((prevMessages) => [...prevMessages, message]);
      
      if (window.config.isChina && !window.config.businessUnit === "HBT-GCEGBT") return;

      if(shouldPlaySound){
        setUnreadMessageCount(prevCount => {
        const next = prevCount + 1;
        localStorage.setItem(UNREAD_KEY, String(next));
        return next;
        });

        const a = pingRef.current
        if (a) {
          try{
            a.currentTime = 0;
            console.log({focused, isChatOpen, shouldPlaySound, isRead});
            void a.play().catch(e => console.log("sound blocked:", e.name, e.message));
          } catch (e) {
            console.log("sound error:", e)
          }
        }
      }
    };
  
useEffect(() => {
        if (!window.config.isChina && !window.config.businessUnit === "HBT-GCEGBT") return;
        const savedCount = parseInt(localStorage.getItem(UNREAD_KEY) || '0', 10);
        if (!isNaN(savedCount)) {
        setUnreadMessageCount(savedCount);
        }}, []);

  useEffect(() => {
    if (directLine) {
      const subscription = directLine.activity$.subscribe(handleIncomingMessage);
      return () => subscription.unsubscribe();
    }
  }, [directLine]);

//Reset Notifications once chat is opened
  useEffect(() => {
      if(isMaximised && isWindowFocused){
      setMessages((prevMessages) =>
        prevMessages.map((msg) => ({ ...msg, read: true }))
      );
      setUnreadMessageCount(0);
      localStorage.removeItem(UNREAD_KEY);
    }
  }, [isMaximised, isWindowFocused]);


  const handleMenuItemClick = (selectedMenuItem) => {
    context.setMenuOpen(false);
    if (store != null && getCookie(window.config.businessUnit + '-EnableSendBox')) {
      store.dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "enableSendBoxEventReceived",
        }
      });
    }
    context.setDisableSendBox(true);
    store.dispatch({
      type: "WEB_CHAT/SEND_MESSAGE",
      payload: {
        text: selectedMenuItem
      }
    });
  }

  // live agent ENGLISH (EN) availability
  const checkLiveAgentAvailability = () => {
    let currenttime = new Date();
    const opentime1 = '08:00:00';
    const opentime2 = '00:00:00';
    const closetime = '03:30:00';
    let newtimezonedate = momenttimezone.utc(currenttime, null).tz('Asia/Kolkata');
    let currentday = newtimezonedate.format('d');
    let presentTime = newtimezonedate.format('HH:mm:ss');
    switch (currentday) {
      // Sunday
      case '0':
        return false;
      //Saturday
      case '6':
        if (presentTime > opentime2 && presentTime < closetime) {
          context.setCheckLiveAgentAvailable(true);
          return true;
        }
        return false;
      //Monday
      case '1':
        if (!(presentTime > opentime2 && presentTime < opentime1)) {
          context.setCheckLiveAgentAvailable(true);
          return true;
        }
        return false;
      case '2':
      case '3':
      case '4':
      case '5':
        if (!(presentTime > closetime && presentTime < opentime1)) {
          context.setCheckLiveAgentAvailable(true);
          return true;
        }
        return false;
      default:
        return false;
    }
  }

  const checkLiveAgentAvailabilityForOtherLanguages = (
    closeTime = '16:00:00'
  ) => {
    let currenttime = new Date();
    const opentime = '08:00:00';
    const closetime = closeTime;
    let newtimezonedate = momenttimezone.utc(currenttime, null).tz('Europe/Berlin');
    let currentday = newtimezonedate.format('d');
    let presentTime = newtimezonedate.format('HH:mm:ss');
    switch (currentday) {
      // Sunday
      case '0':
        return false;
      //Saturday
      case '6':
        return false;
      //Monday,Tuesday,Wednesday,Thursday and Friday
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
        if (presentTime > opentime && presentTime < closetime) {
          context.setCheckLiveAgentAvailable(true);
          return true;
        }
        return false;
      default:
        return false;
    }
  }


  useEffect(() => {
    let liveAgentAvailable;
    context.setShowHeaderFooter(false);
    context.setShowSendBox(false);
    context.setEnableScroll(false);
    context.setHideStickyMenu(true);
    if (window.config.businessUnit === "HBT-GCEGBT" && (HBTPages?.includes(window.config.pageTitle)) || BrandBasedPages?.includes(window.config.pageTitle)) {
      // ENGLISH
      if (window.config.preLoginSalesPages.includes(window.config.pageTitle) && window.config.language === 'en') {
        liveAgentAvailable = checkLiveAgentAvailability();
      }
      // GERMAN
      else if (window.config.preLoginSalesPages.includes(window.config.pageTitle) && window.config.language === 'de') {
        liveAgentAvailable = checkLiveAgentAvailabilityForOtherLanguages('16:00:00');
      }
      // FRENCH
      else if (window.config.preLoginSalesPages.includes(window.config.pageTitle) && window.config.language === 'fr') {
        liveAgentAvailable = checkLiveAgentAvailabilityForOtherLanguages('17:00:00');
      }
      // DUTCH
      else if (window.config.preLoginSalesPages.includes(window.config.pageTitle) && window.config.language === 'nl') {
        liveAgentAvailable = checkLiveAgentAvailabilityForOtherLanguages('17:00:00');
      }
      // ITALIAN
      else if (window.config.preLoginSalesPages.includes(window.config.pageTitle) && window.config.language === 'it') {
        liveAgentAvailable = checkLiveAgentAvailabilityForOtherLanguages('17:00:00');
      }
      // SPANISH
      else if (window.config.preLoginSalesPages.includes(window.config.pageTitle) && window.config.language === 'es') {
        liveAgentAvailable = checkLiveAgentAvailabilityForOtherLanguages('17:00:00');
      }
      else {
        context.setCheckLiveAgentAvailable(true);
      }
    }
   
    // if(window.config.businessUnit === "HBT-GCEGBT"  && ['login'].includes(window.config.pageTitle)) {
    //   const timeout = setTimeout(() => {
    //     if(!isMaximised && getWithExpiry(window.config.pageTitle) === null && liveAgentAvailable) {
    //       ChatWithLiveAgentBotClick();
    //     }
    //    },20000);
    //    return () => clearTimeout(timeout);
    // }
  }, []);
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (window.config.businessUnit === "HBT-GCEGBT") {
  //      // console.log('Page Change Detected', currentPageTitle);

  //       window.parent.postMessage({ key: 'page_title', origin: window.location.origin }, window.config.pageOrigin);
  //       window.parent.postMessage({ key: 'page_language', origin: window.location.origin }, window.config.pageOrigin);
  //       window.parent.postMessage({ key: 'page_country', origin: window.location.origin }, window.config.pageOrigin);

  //       window.onmessage = (e) => {
  //         //console.log('page_title Event', e.data)
  //         let data
  //         switch (e.data.key) {
  //           case 'page_title':
  //             data = JSON.parse(JSON.stringify(e.data));
  //             window.config.pageTitle = data.pageTitle;
  //             setCurrentPageTitle(data.pageTitle)
  //             break;
  //           case 'page_language':
  //             data = JSON.parse(JSON.stringify(e.data));
  //             //console.log('Triggerred Page Language Change', data);
  //             window.config.language = data.pageLanguage;
  //             setCurrentPageLanguage(data.pageLanguage);
  //             break;
  //           case 'page_country':
  //             data = JSON.parse(JSON.stringify(e.data));
  //             console.log('Triggerred Page Language Change', data);
  //             window.config.countrySelectedOnPortal = data.countrySelectedOnPortal;
  //             setCurrentCountrySelectedOnPortal(data.countrySelectedOnPortal);
  //             break;
  //           case 'page_country':
  //             data = JSON.parse(JSON.stringify(e.data));
  //            // console.log('Triggerred Page Country Change', data);
  //             window.config.countrySelectedOnPortal = data.countrySelectedOnPortal;
  //             setCurrentCountrySelectedOnPortal(data.countrySelectedOnPortal);
  //             break;
  //           default:
  //             break;
  //         }
  //       };
  //     }
  //   }, 1500)
  // }, [currentPageTitle, currentPageLanguage, currentCountrySelectedOnPortal])

  const updateContextVariablesData  = () => {
    if (getCookie(window.config.businessUnit + '-Token') &&
      getCookie(window.config.businessUnit + '-Conversation') &&
      getCookie(window.config.businessUnit + '-AuthToken') &&
      getCWACookies("cwaSSOToken") &&
      getCookie(window.config.businessUnit + '-AuthToken').length === getCWACookies("cwaSSOToken").length
    ) {
      if (window.config.businessUnit === 'HBT-GCEGBT' || window.config.businessUnit === 'SPS-ECOMM') {
        if (getCookie(window.config.businessUnit + '-Language') &&
          getCookie(window.config.businessUnit + '-Language') === window.config.language) {
          context.setShowHeaderFooter(true);
          context.setShowSendBox(true);
          context.setEnableScroll(true);
          context.setHideStickyMenu(false);
        }
      }
      else {
        context.setShowHeaderFooter(true);
        context.setShowSendBox(true);
        context.setEnableScroll(true);
        context.setHideStickyMenu(false);
      }

    }
  }
  const updateContextVariables=()=>{
    if(window.config.isNewPrivacy==true){
      if(getCookie(window.config.businessUnit + '-isPrivacyAccepted')){
      updateContextVariablesData();
      }
    }
    else{
      updateContextVariablesData();
    }
  }



  const botIconClick = async () => {
    // console.log("Bot icon clicked:", Date.now()) 
    context.setBotClicked(true); // Mark as called
    if (window.config.businessUnit === "HBT-GCEGBT" &&!shouldDisplayNewIcon()) {
      handleMouseLeave();
    }
    // if (window.config.businessUnit === "HBT-GCEGBT" && window.config.pageTitle == "login") {
    //   window.config.isNewSSO = false
    // }
    handleMaximizeChange();
    updateContextVariables();
  }
 const shouldCheckInactivity =  () => {
  if (disableProactivity()) return false;
  if (window.config.proactiveInactivityTriggered) return false;
  // Get the page URL from localStorage and ensure it's valid
  if(localStorage.getItem("pageUrl")=="undefined") return false;
  return window.config.isProactiveEnable || false; 
};
  useEffect(() => {
  if (!window.config.isChina && window.config.businessUnit=="HBT-GCEGBT" && shouldCheckInactivity()) {
    const interval = setInterval(() => {
      if (
        disableProactivity() ||
        window.config.proactiveInactivityTriggered
      ) return;
      const currentTime = Date.now();
      context.lastCall=sessionStorage.getItem("proactiveInactivity");
      const timeSinceLastCall = (currentTime - context.lastCall) / 1000;

      console.log(`Time since last call: ${timeSinceLastCall} seconds ${String(context.hasAutoTriggered)}`);
      
      const businessUnit = window.config.businessUnit;

      // Ensure the time and conditions are met
      if (
        timeSinceLastCall > window.config.proactivedelay && 
        !context.botClicked  && !context.hasAutoTriggered && 
        window.config.businessUnit === "HBT-GCEGBT"
      ) {
        console.log("botIconClick is being called automatically after 40 seconds.");
        
        const isAuthenticated =
          getCookie(`${businessUnit}-Token`) &&
          getCookie(`${businessUnit}-Conversation`) &&
          getCookie(`${businessUnit}-AuthToken`) &&
          getCWACookies('cwaSSOToken') &&
          getCookie(`${businessUnit}-AuthToken`).length === getCWACookies('cwaSSOToken').length &&
          getCookie(`${businessUnit}-Language`) &&
          getCookie(`${businessUnit}-Language`) === window.config.language;
        // Trigger botIconClick and set 'hasAutoTriggered' to true
        if (!isAuthenticated) {
          window.config.proactiveInactivityTriggered = true;
          context.setHasAutoTriggered(true);
          botIconClick();
        }
      }
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }
}, [context.lastCall, context.botClicked,window.config.isProactiveEnable]);
  useImperativeHandle(ref, () => ({
        botIconClick
  }));
  const handleMouseOver = (event) => {
    // if(event && event.stopPropagation){
    // event.stopPropagation();
    // }
    // setTimeout(()=>{
    //   if(document.getElementById("logo")){
      document.getElementById("logo").style.display = 'none';
      document.getElementById("logoNew").style.display = 'inline-flex';
     window.parent.postMessage({ key: 'show_hoverLogo' }, window.config.pageOrigin);
  }

  const handleMouseLeave = () => {
   document.getElementById("logo").style.display = 'block';
    document.getElementById("logoNew").style.display = 'none';
    window.parent.postMessage({ key: 'close_launcher' }, window.config.pageOrigin);
  }

 

 

  const minimizeBot = () => {
    document.getElementById('root').classList.remove('root-min');
    window.parent.postMessage({ key: 'minimise_bot', origin: window.location.origin }, window.config.pageOrigin);
    handleMaximizeChange();
    setTimeout(() => {
      if (document.getElementById('logo')) {
        document.getElementById('logo').style.display = "block";
      }
    }, 1000)
  };

  const pageRenderSwitch = (pageTitleValue) => {
    const salesPages = (window.config.language in salesPagesMessages) ? salesPagesMessages[window.config.language] : {};
    return (pageTitleValue in salesPages) ? salesPages[pageTitleValue] : '';
  }

  
  var launcherIcon = classNames({
    launcherIcon: true,
    notificationAnimation: window.config.businessUnit === "HCE-MARKETING"
  });

  var launcherIconHoneywellAssit = classNames({
    launcherIconHoneywellAssit: true,
    botIconAnimation: window.config.businessUnit === "HCE-MARKETING"
  });
 const isAllowedPath = (path) => {
    // Check if the path starts with '/products/by-category/' and contains more segments after it
    return path.startsWith('/products/by-category/') && path !== '/products/by-category/';
 };

// Function to check if the current URL is in pageArray
const shouldDisplayNewIcon = () => {
  //const displayIconBig=window.config.pageBigIconArray?.some(bigIconPath => pathname.includes(bigIconPath)) || false;
  if(window.config.pageBigIconArray){
  window.parent.postMessage({ key: 'show_hoverLogo' }, window.config.pageOrigin);
  }
  return window.config.pageBigIconArray || false;
};
const renderHBTGCEGBT = () => {
 
    if (window.config.languageEnabled.includes(window.config.language)) {
      return (<div>
        <div className="logoOverflow">
          { window.config.businessUnit=="HBT-GCEGBT" && !window.config.isChina && shouldDisplayNewIcon() ? <img className="minimizedLauncherIcon_NewHBT_showDefault"
            alt="miniAvatar"
            id="logoNew"
            src={ChatbotLogo_NewHBT}
            onClick={botIconClick} />:
          <><img className="minimizedLauncherIcon_HBT"
            alt="miniAvatar"
            id="logo"
            src={ChatbotLogo_HBT}
            onMouseOver={handleMouseOver}
            onClick={botIconClick} />
          <img className="minimizedLauncherIcon_NewHBT"
            alt="miniAvatar"
            id="logoNew"
            src={ChatbotLogo_NewHBT}
            onMouseLeave={handleMouseLeave}
            onClick={botIconClick} /></>
          }
        </div>
      </div>);
    }
    else if(window.config.language === 'zh' && window.config.isChina){
      return (<div>
        <div className="logoOverflow">
          <img className="minimizedLauncherIcon_HBT"
            alt="miniAvatar"
            id="logo"
            src={ChatbotLogo_HBT}
            onMouseOver={handleMouseOver}
            onClick={botIconClick} />
          <img className="minimizedLauncherIcon_NewHBT"
            alt="miniAvatar"
            id="logoNew"
            src={ChatbotLogo_NewHBT}
            onMouseLeave={handleMouseLeave}
            onClick={botIconClick} />
        </div>
      </div>);
    }
}

  const renderHBTGCEGBT_HEADER = () => {
    return (
      <div className={headerClass}>
        <div className="ask-ellie">
          <img
            className="launcherIconAvatar launcherBlock"
            alt="miniAvatar"
            src={HeaderLogo_HBT}
          />
          <h4 style={{ fontWeight: '600' }}>{window.config.businessUnit === "HCE-TRIDIUM" ? 'Tridium Assist' : 'Honeywell Assist'}</h4>
        </div>
        {headerIconsDisplay ? (
          <ul>
            <li>
            {window.config.isAdjustable ?<a href="#" onClick={toggleMaximize}>
              <img 
                className="maximizeHeaderIcon"
                alt={localMaximized ? "Restore" : "Maximize"}
                title={localMaximized ? "Restore" : "Maximize"}
                src={localMaximized ? RestoreIcon : MaximizeIcon}
              />
            </a>:null}
          </li>
            <li>
              <a href="#" onClick={minimizeBot}>
                <img
                  alt="Minimize"
                  title="Minimize Bot"
                  src={Minimize}
                ></img>
              </a>
            </li>

            <li>
              <a
                href="#"
                onClick={context.showSurvey ? handleModalChange({
                  isOpenModal: false,
                  value: null,
                  target: "closeWithSurvey"
                }) : handleModalChange({
                  isOpenModal: true,
                  value: null,
                  target: "close"
                })}
              >
                <img alt="Close" title="Close Bot" src={Close}></img>
              </a>
            </li>
          </ul>
        ) : surveyLink === "" ? "" :
          (
            <ul>
              <li>
                <a
                  href="#"
                  onClick={handleModalChange({
                    isOpenModal: true,
                    value: null,
                    target: "shutdown"
                  })}
                >
                  <img alt="Close" title="Close Bot" src={Close}></img>
                </a>
              </li>
            </ul>
          )}
      </div>
    )
  }

//Notification Bubble visible logic
  const renderMinimizedBotIcon = () => (
    <div>
      {!window.config.isChina && window.config.businessUnit === "HBT-GCEGBT" && !isMaximised && unreadMessageCount > 0 && (
        <span className="unread-message-badge">
          {unreadMessageCount > 9 ? "9+" : unreadMessageCount}
        </span>
      )}
    </div>
  );

  return (
    <div>
      {renderMinimizedBotIcon()}
      {isMaximised ? (
        context.showHeaderFooter &&
        (window.config.isNewUI ?
          renderHBTGCEGBT_HEADER()
          :
          <div className={headerClass}>
            <div className="ask-ellie">
              <img
                alt="MenuIcon"
                src={MenuIcon}
                onClick={handleMenuClick}
                style={{ cursor: 'pointer', display: context.hideStickyMenu ? 'none' : 'block' }}
              />
              <div className="vertical" style={{ display: context.hideStickyMenu ? 'none' : 'block' }}></div>
              {window.config.businessUnit === "HBT-GCEGBT" ?
                <img
                  className="launcherIconAvatar"
                  alt="miniAvatar"
                  src={HeaderLogo_HBT}
                /> :
                <img
                  className="launcherIconAvatar"
                  alt="miniAvatar"
                  src={HeaderLogo}
                />}

              {window.config.businessUnit === "HCE-TRIDIUM" ? <h4>Tridium Assist</h4> : <h4>Honeywell Assist</h4>}
            </div>
            {headerIconsDisplay ? (
              <ul>
                {window.config.businessUnit === "SPS-PPR" || window.config.businessUnit === "SPS-ECOMM" ?
                  <li>
                    <a
                      href={window.config.helpVideoLink}
                      target="_blank"
                      className="helpVideoLink"
                      title="DCA help page 'How to'"
                    >
                      ?
                    </a>
                  </li> : ""
                }
                 <li>
                <a href="#" onClick={toggleMaximize}>
                  <img
                    className="maximizeHeaderIcon"
                    alt={isMaximised ? "Restore" : "Maximize"}
                    title={isMaximised ? "Restore" : "Maximize"}
                    src={isMaximised ? RestoreIcon : MaximizeIcon}
                  ></img>
                </a>
              </li>
                <li>
                  <a href="#" onClick={minimizeBot}>
                    <img
                      alt="Minimize"
                      title="Minimize Bot"
                      src={Minimize}
                    ></img>
                  </a>
                </li>
                {!context.hideStickyMenu ?
                  <li>
                    <a
                      href="#"
                      onClick={handleModalChange({
                        isOpenModal: true,
                        value: null,
                        target: "refresh"
                      })}
                    >
                      <img alt="Refresh" title="Refresh Bot" src={Refresh}></img>
                    </a>
                  </li> : ""
                }
                <li>
                  <a
                    href="#"
                    onClick={window.config.businessUnit === "HCE-TRIDIUM" ? closeIconClick : context.showSurvey ? handleModalChange({
                      isOpenModal: false,
                      value: null,
                      target: "closeWithSurvey"
                    }) : handleModalChange({
                      isOpenModal: true,
                      value: null,
                      target: "close"
                    })}
                  >
                    <img alt="Close" title="Close Bot" src={Close}></img>
                  </a>
                </li>
              </ul>
            ) : surveyLink === "" ? "" :
              (
                <ul>
                  <li>
                    <a
                      href="#"
                      onClick={handleModalChange({
                        isOpenModal: true,
                        value: null,
                        target: "shutdown"
                      })}
                    >
                      <img alt="Close" title="Close Bot" src={Close}></img>
                    </a>
                  </li>
                </ul>
              )}
          </div>)
      ) : (window.config.businessUnit === "HBT-GCEGBT" ? renderHBTGCEGBT() :
        <div><div className="logoOverflow">
        <img className="minimizedLauncherIcon_HBT"
          alt="miniAvatar"
          id="logo"
          src={ChatbotLogo_HBT}
          onMouseOver={handleMouseOver}
          onClick={botIconClick} />
        <img className="minimizedLauncherIcon_NewHBT"
          alt="miniAvatar"
          id="logoNew"
          src={ChatbotLogo_NewHBT}
          onMouseLeave={handleMouseLeave}
          onClick={botIconClick} />
      </div>
        </div>
      )}
      {document.getElementById("main") === null ? (
        ""
      ) : (
        !!directLine ?
          <Components.Composer
            directLine={directLine}
            store={store}

          >
            <ChatModal
              isOpenModal={isOpenModal}
              handleModalChange={handleModalChange}
              userLanguage={userLanguage}
              handleRefreshModalPopup={handleRefreshModalPopup}
              handleCloseModalPopup={handleCloseModalPopup}
              handleMaximizeChange={handleMaximizeChange}
            />
          </Components.Composer> : ""
      )}
      {(context.menuOpen && !window.config.isNewUI) ?
        <div className="menuContainer">
          {window.config.businessUnit === 'SPS-GDM' || window.config.businessUnit === 'SPS-PSS' ?
            context.menuItems.map((menuItem, index) => (
              <p key={index} className="menuItem" onClick={() => handleMenuItemClick(menuItem.buttonText)} >{menuItem.buttonText} </p>))
            :
            context.menuItems.map((menuItem, index) => (
              <p key={index} className="menuItem" onClick={() => handleMenuItemClick(menuItem)} >{menuItem} </p>))
          }
        </div>
        : ""
      }
      {
        context.isLiveAgent && window.config.isNewUI && !isSurveyOpen && <div className={agentBadge}>
          <div style={{ fontWeight: '500', margin: '5px 0px' }}>
            <div className="displayFlex"><span className="noMargin">{
            window.config.language ?
              liveAgentStaticLabels[window.config.language]?.liveagentConnected :
              liveAgentStaticLabels?.en?.liveagentConnected
          } &nbsp;</span><h4 className="agentNameStyle">{context.liveAgentName}</h4></div>
            {context.transcriptTranslationRequired ? <div className="displayFlex"><span className="translatedAIStyle">{
            window.config.language ?
              liveAgentStaticLabels[window.config.language]?.translatedBy :
              liveAgentStaticLabels?.en?.translatedBy
          } &nbsp;</span></div>:null}
          </div>
          {/* <p style={{ fontWeight: '500', margin: '5px 0px' }}>{
            window.config.language ?
              liveAgentStaticLabels[window.config.language]?.liveagentConnected :
              liveAgentStaticLabels?.en?.liveagentConnected
          }</p>  */}
        </div>
      }
    </div>
  );
});

export default Header;